import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtual from '../../actions/empresa/determinarPaginaAtualEmpresas'
import alterarRegistrosPorPagina from '../../actions/empresa/alterarRegistrosPorPaginaEmpresas'

export class PaginacaoEmpresas extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualEmpresa,
    total: state.empresasGestao.total,
    registrosPorPagina: state.registrosPorPaginaEmpresa
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoEmpresas)
